(() => {
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:window.Shopify?.currency?.active || 'USD',minimumFractionDigits:cents % 100 ? 2 : 0}).format(cents / 100);
  class HostingCountdown extends HTMLElement {
    connectedCallback() {
      const tick = () => {
        const target = Date.parse(this.dataset.target);
        const ms = Math.max(0, target - Date.now());
        const clock = this.querySelector('[data-clock]');
        if (!Number.isFinite(target)) { clock.textContent = ''; return; }
        if (!ms) { clock.textContent = this.dataset.expired; return; }
        const d = Math.floor(ms/86400000), h = Math.floor(ms/3600000)%24, m = Math.floor(ms/60000)%60;
        if (this.classList.contains('vh-countdown--compact')) clock.textContent = `${d} days, ${h} hrs`;
        else clock.innerHTML = [[d,'Days'],[h,'Hours'],[m,'Minutes']].map(([n,label])=>`<span><b>${String(n).padStart(2,'0')}</b><small>${label}</small></span>`).join('');
      };
      tick(); this.timer = setInterval(tick,30000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
  }
  if (!customElements.get('vh-hosting-countdown')) customElements.define('vh-hosting-countdown', HostingCountdown);
  function init(root = document) {
    const form = root.querySelector('[data-hosting-form]');
    if (!form || form.dataset.initialized) return;
    form.dataset.initialized = 'true';
    const section = form.closest('.vh-hosting-buy');
    const bundles = Object.fromEntries([...form.querySelectorAll('[data-bundle]')].map(el=>[el.dataset.bundle,JSON.parse(el.textContent)]));
    const main = section.querySelector('[data-gallery-main]'), thumbs = section.querySelector('[data-gallery-thumbs]');
    let currentKey;
    function setImage(image, index) {
      const img = document.createElement('img'); img.src = image.src; img.alt = image.alt; img.width=1200; img.height=1200;
      main.replaceChildren(img);
      [...thumbs.children].forEach((b,i)=>b.setAttribute('aria-current',String(i===index)));
    }
    function render() {
      const key = form.elements.hosting_bundle.value, bundle = bundles[key];
      if (!bundle) return;
      if (!bundle.plan && form.elements.hosting_type.value==='sub') form.elements.hosting_type.value='once';
      const sub = form.elements.hosting_type.value==='sub';
      form.querySelector('[data-sub-option]').hidden = !bundle.plan;
      form.querySelector('[data-sub-label]').textContent = `Subscribe & save ${Math.round((1-bundle.sub/bundle.once)*100)}%`;
      form.querySelector('[data-variant]').value=bundle.id;
      const plan = form.querySelector('[data-plan]');plan.disabled=!sub;plan.value=sub?bundle.plan:'';
      form.querySelector('[data-atc]').disabled=!bundle.available;
      form.querySelector('[data-atc-label]').textContent=bundle.available?'Add to cart':'Sold out';
      const price=sub?bundle.sub:bundle.once;
      form.querySelector('[data-atc-price]').textContent=money(price);
      section.querySelector('[data-sticky-title]').textContent=`${bundle.title} · ${money(price)}`;
      for (const [id,b] of Object.entries(bundles)) {
        const label=form.querySelector(`input[value="${id}"]`).closest('label');
        const p=sub && b.plan?b.sub:b.once, compare=sub && b.plan?b.once:b.compare;
        label.querySelector('[data-price]').textContent=money(p);
        label.querySelector('[data-compare]').textContent=compare>p?money(compare):'';
        label.querySelector('[data-per-glass]').textContent=`${money(p/b.servings)} a glass`;
      }
      if (key!==currentKey) {
        thumbs.replaceChildren();
        bundle.images.forEach((image,i)=>{const b=document.createElement('button');b.type='button';b.setAttribute('aria-label',`View ${bundle.title} image ${i+1}`);const img=document.createElement('img');img.src=image.src;img.alt='';img.loading='lazy';b.append(img);b.addEventListener('click',()=>setImage(image,i));thumbs.append(b)});
        if(bundle.images[0])setImage(bundle.images[0],0);else main.replaceChildren();
        currentKey=key;
      }
    }
    form.addEventListener('change',render);render();
    // Retain native cart submission: UpCart intercepts this form as on existing landing pages.
    const sticky = section.querySelector('[data-hosting-sticky]');
    const watched = [section,document.querySelector('[id$="__hosting_hero"]'),document.querySelector('[id$="__hosting_final"]'),document.querySelector('[id$="__footer"]')].filter(Boolean);
    const visible = new Map(watched.map(el=>[el,true]));
    const observer = new IntersectionObserver(entries=>{entries.forEach(e=>visible.set(e.target,e.isIntersecting));sticky.hidden=[...visible.values()].some(Boolean);},{threshold:0.05});
    watched.forEach(el=>observer.observe(el));
  }
  document.addEventListener('DOMContentLoaded',()=>init());
  document.addEventListener('shopify:section:load',e=>init(e.target));
  // Stable anchor targets on generic section wrappers, independent of Shopify's template ID.
  document.addEventListener('DOMContentLoaded',()=>{for(const key of ['faq','final','top']){const suffix=key==='top'?'hero':key;const el=document.querySelector(`[id$="__hosting_${suffix}"]`);if(el){const anchor=document.createElement('span');anchor.id=key;el.prepend(anchor)}}});
})();
